import { createApp } from 'vue'
import './styles.css'
import HelloWorld from '../components/shared/HelloWorld.vue'
import WorkspaceSwitcher from '../components/shell/WorkspaceSwitcher.vue'
import TasksView from '../components/tasks/TasksView.vue'

const components = {
  HelloWorld,
  WorkspaceSwitcher,
  TasksView,
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-vue-component]').forEach((el) => {
    const name = el.dataset.vueComponent
    const component = components[name]

    if (!component) {
      console.warn(`Vue component "${name}" not found in registry`)
      return
    }

    const props = el.dataset.vueProps ? JSON.parse(el.dataset.vueProps) : {}
    createApp(component, props).mount(el)
  })
})
